const message_properties = [
  {
    id: 1,
    message: "HAPPY",
    color: "#b187b7"
  },
  {
    id: 2,
    message: "BIRTHDAY",
    color: "#755677"
  },
  {
    id: 3,
    message: "ZOË",
    color: "#b187b7"
  },
];

export { message_properties };
